import React from "react";

import styled, { keyframes } from "styled-components/macro";

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
`

export const LoaderWrapper = styled.div`
  width: 48px;
  height: 48px;
  border: 5px solid #141414;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: ${rotate} 1s linear infinite;
`;

export const Loader = () => {
  return (
    <Container>
      <LoaderWrapper />
    </Container>
  )
}

